import request from './request'
// import axios from 'axios'
import qs from 'qs'


const url = {
    common: {
        // 根据类型获取拒绝理由*
        // type 1:跟进释放理由 2：职位关闭理由 3：职位不感兴趣理由 4：用户入驻审核不通过理由 5：技能审核不通过理由, 6: 举报理由
        getReasons: '/common/searchReason',
        getIndustries: '/common/industry',
    },
    sysuser: {
        list: "/sysUser/listUserWithRole",
        detail: '',
        post: '/sysUser/addUser',
        update: "/sysUser/updateUser",
        remove: '/sysUser/deleteUser'
    },
    role: {
        list: "/sysRole/listRoleWithPerm",
        detail: '',
        post: '/sysRole/addRole/',
        update: '/sysRole/updateRole',
        remove: '/sysRole/deleteRole',
        addperm: '/sysRole/addPermForRole'
    },
    per: {
        list: "/sysPermission/listPermissionByParam",
        detail: '',
        post: '/sysPermission/addPermission',
        update: "/sysPermission/updatePermission",
        remove: '/sysPermission/deletePermission'
    },
    log: {
        list: '/optLog/listLogByParam'
    },
    reportLog: {
        list: '/optLog/reportLogByParam'
    },
    workCateList: {
        list: '/work/category/getWorkCateFirst',
        getAll: '/work/category/getWorkCateAllFirst',
        save: '/work/category/saveWorkCate',
        getSkillList: '/work/category/getSkillList',
        updateStatus: '/work/category/updateStatus',
        getAllTags: '/work/category/getAllTags', // 获取所有标签（包含一、二、三级、当前用户自定义）
        getHotCates: '/work/category/getAllHotCategory', // 获取所有热门标签
        addHotCates: '/work/category/createHotCategory', // 新增热门标签
        updateHotCates: '/work/category/updateHotCategory', // 更新热门标签
        delHotCates: '/work/category/delHotCategory', // 删除热门标签
    },
    district: {
        dist: '/district/listDistrictByParam',
        item: '/district/getDistrictById',
        post: '/district/addDistrict',
        update: '/district/updateDistrict',
        remove: '/district/deleteDistrict'
    },
    user: {
        showList: '/user/showList',
        showIndex: '/resume/push',
        cancelShowIndex: '/resume/cancelPush',
        export: '/user/export',
        exportResume: '/user/exportUserResume',
        item: '/user/getUserById',
        list: '/user/listUserByParam',
        listCheck: '/user/listCertificationUser',
        update: '/user/updateUser',
        remove: '/user/deleteUser',
        skill: '/skill/getSkillByUserId',
        detail: '/user/getUserById',
        resumeList: '/user/listResumeByParam',
        check: '/user/updateUserStatus',
        level: '/userRating/query_user_rating',
        levelDetail: '/userRating/get_user_rating_detail',
        updateLevel: '/userRating/save_user_rating',
        enableOrDisableUser: '/user/enableOrDisableUser',
        exportPartA: '/user/exportPartyA',
        msgs: '/im/listImMessageByParams',
        sessions: '/im/listConversationByParams',
        exportMsgs: '/im/export',
        vertifyInfo: '/certification/getAccountInfo',
        updateBanStatus: '/user/updateUserBanStatus',
        cleanCertification: '/user/cleanCertification',
        unBanApplies: '/user/unBanApply',
        updateUnBanApply: '/user/updateApply',
        updateLimit: '/user/updateLimit',
        baseInfo: '/user/info',
        feedbacks: '/appRecommend/list',
        violations: '/violation/list',
        rechargeYunDou:'/propTool/rechargeProp',
        getUserInfo: '/user/getUserCertificationInfo', // 查看用户认证信息
        updateStatus: '/user/updateUserCertificationStatus', // 更新用户认证状态

    },
    client: {
        clients: '/client/listClientByParams',
        clientInfo: '/follow/get_snap_follow',
        export: '/client/export',
        levelInfo: '/gradeScore/getGradeUser',
        computedLevel: '/gradeScore/insert',
        follows: '/follow/get_all_follow',
        followDetail: '/follow/get_follow_info',
        followSave: '/follow/save_follow',
        exportFollows: '/follow/exportFollow',
    },
    order: {
        list: '/order/queryOrder',
        contracts: '/contract/getContractList',
        forceStopOrder: '/order/forceStopOrder',
        token: '/contract/getEncryptCode',
        export: '/order/exportOrder',
        detail: '/contract/getContractDetail',
        update: '/contract/updateContractInfo',
        updateDcn: '/order/update/dcn',
    },
    clue: {
        list: '/orderCule/listOrderCuleByParam'
    },
    get: {
        list: '/withdraw/listWithdrawByParams',
        update: '/withdraw/update'
    },
    trade: {
        list: '/orderRecord/listOrderRecordByParam'
    },
    need: {
        list: '/orderNeed/listOrderNeedByParam'
    },
    login: '/login',
    data: {
        userEnter: '/userEntering/listItemByPeriod',
        demand: 'data/orderNeeds',
        price: '/data/ave',
        record: "/data/orderNeedsBySucc",
        income: '/data/orderCule',
    },
    menu: '/sysUser/getUserPerms',
    refund: {
        list: '/refund/listRefundByParam',
        update: '/refund/updateStatus',
    },
    withdraw: {
        list: '/withdraw/listWithdrawByParams',
        update: '/withdraw/updateStatus',
    },
    pay: {
        list: '/deposit/getDepositList',
        updateInfo: '/deposit/updateDepositInfo',
        updateStatus: '/deposit/updateDepositStatus',
        export: '/deposit/depositExport',
        exportPayDetail: 'deposit/depositDetailExport',
        totalAmount: '/deposit/totalAmount'
    },
    withdrawal: {
        list: '/withdrawal/listWithdrawalByParams',
        updateClientWithdrawal: '/withdrawal/updateClientWithdrawal',
        review: '/withdrawal/review',
        export: '/withdrawal/export',
        confirmProviderWithdrawal: '/withdrawal/confirmProviderWithdrawal',
        withdrawalId: '/withdrawal/{id}',
        againLaunchPay: '/withdrawal/againLaunchPay',
        completed: '/withdrawal/yeyun/completedWithdraw',
        transferAccount: '/withdrawal/zhonglebang/transferAccount',
    },
    prepay: {
        list: '/prepayment/listPrepaymentByParams',
        updateStatus: '/prepayment/updateStatus',
        update: '/prepayment/update',
    },
    settlement: {
        // list: '/billing/listOrderBillingByParam',
        list: '/billing/queryBilling',
        export: 'billing/export'
    },
    payChannel: {
        get: '/config/payment/channel',
        update: '/config/payment/channel/update',
    },
    upload: {
        token: '/token/upload_file',
    },
    job: {
        list: '/job/listAllJob',
        quotes: '/quotation/listAllQuotation',
        push: '/job/pushToFreelancers',
        pushRecords: '/job/historyPushToFreelancers',
        // showIndex: '/orderNeed/pushToIndex',
        // cancelShowIndex: '/orderNeed/cancelPush',
        showHot: '/job/hot/pushOrCancel',
        // export: '/job/exportJob',
        export: '/job/export',
        detail: '/job/getDetail',
        update: '/job/updateJob',
        switch: '/job/jobSwitch',
        matchAgain: '/pushFreelancer/push',
    },
    standardJob: {
        list: '/standardPost/list',
        insert:'/standardPost/insert',
        delete:'/standardPost/delete',
        detail:'/standardPost/getById',
        update :'/standardPost/update'

    },
    match: {
        list: '/pushFreelancer/listPushFreelancerLogByParams',
        update: '/pushFreelancer/review',
        tool: '/pushFreelancer/simulate',
        config: '/config/match/list',
        updateConfig: '/config/match/update',
    },
    cate: {
        list: '/work/category/getSkillTagsAll',
        showInCategory: '/work/category/updateCategoryShow',
        detail: '/work/category/categoryDetail',
    },
    invoice: {
        list: '/invoice/listInvoiceByParams',
        detail: '/invoice/getInvoiceDetail',
        reject: '/invoice/reject',
        confirm: '/invoice/confirm',
        export: '/invoice/export'
    },
    account: {
        list: '/account/listAccountByParams',
        export: '/account/export'
    },
    coupon: {
        activities: '/coupon_activity/list',
        coupons: '/coupon_activity/coupon_list',
        create: '/coupon_activity/create',
        update: '/coupon_activity/update',
        detail: '/coupon_activity/detail',
        updateStatus: '/coupon_activity/update_coupon_status',
        exportExcel: '/coupon_activity/coupon_export',
        assign: '/coupon_activity/batchAssign',
        couponCreate: '/coupon_package/create',
        couponPackage: '/coupon_package/list',
        packageDel: '/coupon_package/del',
        Package: '/coupon_package/getCouponPackageById',
        updatePackage: '/coupon_package/update'


    },
    appeal: {
        list: '/complain/complainList',
        detail: '/complain/complainDetail',
        updateStatus: '/complain/changeComplainStatus',
    },
    solution: {
        list: '/solution/getSolutionList',
        detail: '/',
        create: '/solution/addSolution',
        update: '/solution/updateSolution',
    },
    wx: {
        push: '/wechat/pushMsg',
    },
    invite: {
        list: '/activity/getInviteList',
        update: '/activity/updateInviteReward'
    },
    interview: {
        detail: '/interview/detail',
        calculate: '/interview/calculate',
        save: '/interview/save',
    },
    config: {
        get: '/config/get',
        updateJobHoverConfig: '/activity/updateJobHoverConfig',
        updateSubsidyConfig: '/activity/updateSubsidyConfig',
        updateIdCardBlackList: '/config/updateIdCardBlackList',
        updateWithdrawalList: '/config/updateWithdrawalList',
        updatePublishJobList: '/config/updatePublishJobList',
        updateKeyWors: '/config/updateWords',
        updateRecommendJobs: '/config/updateRecommendJobs',
        talentSave: '/talentCarousel/save', // 保存
        imgList: '/talentCarousel/getAllList',
        talentConfig: '/talentCarousel/talentConfig'
    },
    service: {
        list: '/microService/list',
        delete: '/microService/delete',
        show: '/microService/showStatus',
        update: '/microService/update',
        insert: '/microService/add',
        detail: '/microService/detail',
        sendProposal: '/microService/updateReviseOpinion',
        search: '/microService/search',
        checkList: '/microService/verifyList',
        editHot: '/microService/editHot',
        findHotList: '/microService/findHotList'
    },
    search: {
        list: '/hotWord/list',
        add: '/hotWord/insert',
        update: '/hotWord/update',
        delete: '/hotWord/delete',
    },
    activity: {
        list: '/activity/list',
        detail: '/activity/detail',
        update: '/activity/update',
        delete: '/activity/delete',
        create: '/activity/insert',
    },
    talentActivity: {
        list: '/talentActivity/list',
        detail: '/talentActivity/detail',
        update: '/talentActivity/update',
        delete: '/talentActivity/delete',
        create: '/talentActivity/insert',
        statistics: '/talentActivity/log/statistics',
    },
    ent: {
        list: '/ent/list',
        member: '/ent/memberList',
    },
    bean: {
        logs: '/bean/logs',
        types: '/common/beanTypeName',
        export: '/bean/export',
        getAllList: '/beanConfig/getAllList',
        add: '/beanConfig/add',
        update: '/beanConfig/update',
        getConfig: '/beanConfig/{id}'


    },
    taskInfo: {
        list: '/taskInfo/list',
        shelvesTask: '/taskInfo/shelvesTask',
        batchAdd: '/taskInfo/batchAdd', // 组合任务
        updateBatch: '/taskInfo/updateBatch',
        taskInfoId: '/taskInfo/getInfo',
        updateFee: '/taskInfo/updateFee',
        pushLogList: '/pushTaskFreelancer/list',
        pushPartyB: '/taskInfo/pushPartyB'
    },
    taskOrder: {
        list: '/taskOrder/list'
    },
    taskOrderSettlement: {
        list: '/taskOrderSettlement/list'
    },
    callInfo: {
        list: '/callInfo/list'
    },
    talentPool:{
        detail: '/talent/getTalentInfoById',
        list: '/talent/getTalentList',
        city:'/district/search_by_parent'
    },
    prop: {
        selectProps: '/propTool/selectProps',
        selectTools: '/propTool/selectTools',
        qryPropOrder: '/propTool/qryPropOrder',
        order: '/propTool/order',
        commitRefund: '/propTool/commitRefund',
        refundList: '/propTool/refundList',
        refundExport: '/propTool/refundExport',
        agreeRefund: '/propTool/agreeRefund',
        refuseRefund: '/propTool/refuseRefund',
        rechargeProp: '/propTool/rechargeProp',
        qryChatLog: '/propTool/qryChatLog',
        qryDeliverLog: '/propTool/qryDeliverLog',
    }
}

function reset(obj) {
    // let res = {}
    // for (var key in obj){
    //  if(obj[key]){
    //    res[key] = obj
    //  }
    // }

    for (var key in obj) {
        if (!obj[key]) {
            delete obj[key]
        }
    }
    return Object.assign({}, obj, { isDeleted: false })
}

export default {
    common: {
        getReasons: (obj) => request.get(url.common.getReasons, { params: reset(obj) }),
        getIndustries: (obj) => request.get(url.common.getIndustries, { params: reset(obj) }),
    },
    //district
    sysuser: {
        list: (obj) => request.get(url.sysuser.list, { params: reset(obj) }),
        update: (obj) => request.post(url.sysuser.update, obj),
        post: (obj) => request.post(url.sysuser.post, obj),
        remove: (obj) => request.post(url.sysuser.remove, obj)
    },
    role: {
        list: (obj) => request.get(url.role.list, { params: reset(obj) }),
        update: (obj) => request.post(url.role.update, obj),
        post: (obj) => request.post(url.role.post, obj),
        remove: (obj) => request.post(url.role.remove, obj),
        addperm: (obj) => request.post(url.role.post, obj),
    },
    per: {
        list: (obj) => request.get(url.per.list, { params: obj }),
        update: (obj) => request.post(url.per.update, obj),
        post: (obj) => request.post(url.per.post, obj),
        remove: (obj) => request.post(url.per.remove, obj)
    },
    order: {
        list: obj => request.get(url.order.list, { params: obj }),
        contracts: obj => request.get(url.order.contracts, { params: reset(obj) }),
        forceStopOrder: obj => request.post(url.order.forceStopOrder, obj),
        token: obj => request.get(url.order.token, { params: reset(obj) }),
        export: obj => request.post(url.order.export, obj, { responseType: 'blob' }),
        detail: obj => request.get(url.order.detail, { params: reset(obj) }),
        update: obj => request.post(url.order.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateDcn: obj => request.post(url.order.updateDcn, obj, { }),
    },
    clue: {
        list: obj => request.get(url.clue.list, { params: reset(obj) })
    },
    need: {
        list: obj => request.get(url.need.list, { params: reset(obj) })
    },
    get: {
        list: obj => request.get(url.get.list, { params: reset(obj) }),
        update: params => request.get(url.get.update, { params }),
    },
    trade: {
        list: obj => request.get(url.trade.list, { params: reset(obj) })
    },
    log: {
        list: (obj) => request.get(url.log.list, { params: reset(obj) })
    },
    reportLog: {
        list: (obj) => request.get(url.reportLog.list, { params: reset(obj) })
    },
    workCateList: {
        list: (obj) => request.get(url.workCateList.list, { params: reset(obj) }),
        getAll: (obj) => request.get(url.workCateList.getAll, { params: reset(obj) }),
        export: params => request.post(url.workCateList.export, params, { responseType: 'blob' }),
        save: (obj) => request.post(url.workCateList.save, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateStatus: (obj) => request.get(url.workCateList.updateStatus, { params: reset(obj) }),
        getSkillList: (obj) => request.get(url.workCateList.getSkillList, { params: reset(obj) }),
        getAllTags: (obj) => request.get(url.workCateList.getAllTags, { params: reset(obj) }),
        getHotCates: (obj) => request.get(url.workCateList.getHotCates, { params: reset(obj) }),
        addHotCates: (obj) => request.post(url.workCateList.addHotCates, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateHotCates: (obj) => request.post(url.workCateList.updateHotCates, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        delHotCates: (obj) => request.post(url.workCateList.delHotCates, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    user: {
        showList: params => request.get(url.user.showList, { params }),
        showIndex: params => request.get(url.user.showIndex, { params }),
        cancelShowIndex: params => request.get(url.user.cancelShowIndex, { params }),
        list: params => request.get(url.user.list, { params }),
        listCheck: params => request.get(url.user.listCheck, { params }),
        resumeList: params => request.get(url.user.resumeList, { params }),
        export: params => request.post(url.user.export, params, { responseType: 'blob' }),
        exportResumeList: params => request.post(url.user.exportResume, params, { responseType: 'blob' }),
        item: params => request.get(url.user.item, { params }),
        update: params => request.post(url.user.update, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        remove: (obj) => request.get(url.user.remove, { params: obj }),
        skill: obj => request.get(url.user.skill, { params: reset(obj) }),
        detail: params => request.get(url.user.detail, { params }),
        check: params => request.post(url.user.check, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        level: params => request.get(url.user.level, { params }),
        levelDetail: params => request.get(url.user.levelDetail, { params }),
        updateLevel: params => request.post(url.user.updateLevel, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        enableOrDisableUser: params => request.post(url.user.enableOrDisableUser, params),
        exportPartA: params => request.post(url.user.exportPartA, params, { responseType: 'blob' }),
        msgs: params => request.get(url.user.msgs, { params }),
        sessions: params => request.get(url.user.sessions, { params }),
        exportMsgs: params => request.post(url.user.exportMsgs, params, { responseType: 'blob' }),
        vertifyInfo: params => request.get(url.user.vertifyInfo, { params }),
        updateBanStatus: params => request.post(url.user.updateBanStatus, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        cleanCertification: params => request.post(url.user.cleanCertification, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        unBanApplies: params => request.get(url.user.unBanApplies, { params }),
        updateUnBanApply: params => request.post(url.user.updateUnBanApply, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateLimit: params => request.post(url.user.updateLimit, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        baseInfo: params => request.get(url.user.baseInfo, { params }),
        feedbacks: params => request.get(url.user.feedbacks, { params }),
        violations: params => request.get(url.user.violations, { params }),
        rechargeYunDou: params => request.post(url.user.rechargeYunDou, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        getUserInfo: params => request.get(url.user.getUserInfo, { params }),
        updateStatus: params => request.post(url.user.updateStatus, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    client: {
        clients: params => request.get(url.client.clients, { params }),
        clientInfo: params => request.get(url.client.clientInfo, { params }),
        export: params => request.post(url.client.export, params, { responseType: 'blob' }),
        levelInfo: params => request.get(url.client.levelInfo, { params }),
        computedLevel: params => request.post(url.client.computedLevel, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        follows: params => request.get(url.client.follows, { params }),
        followDetail: params => request.get(url.client.followDetail, { params }),
        followSave: params => request.post(url.client.followSave, params, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        exportFollows: params => request.post(url.client.exportFollows, params, { responseType: 'blob' }),
    },
    district: {
        list: obj => request.get(url.district.list, { params: reset(obj) }),
        item: obj => request.get(url.district.item, { params: reset(obj) }),
        update: (obj) => request.post(url.district.update, obj),
        post: (obj) => request.post(url.district.post, obj),
        remove: (obj) => request.get(url.district.remove, { params: obj })
    },
    data: {
        user: obj => request.get(url.data.userEnter, { params: reset(obj) }),
        demand: obj => request.get(url.data.demand, { params: reset(obj) }),
        income: obj => request.get(url.data.income, { params: reset(obj) }),
        price: obj => request.get(url.data.price, { params: reset(obj) }),
        record: obj => request.get(url.data.record, { params: reset(obj) }),
    },
    login: params => request.get(url.login, { params }),
    menu: params => request.get(url.menu, { params }),
    refund: {
        list: obj => request.get(url.refund.list, { params: obj }),
        update: obj => request.get(url.refund.update, { params: obj }),
    },
    withdraw: {
        list: obj => request.get(url.withdraw.list, { params: obj }),
        update: obj => request.post(url.withdraw.update, obj),
    },
    prepay: {
        list: obj => request.get(url.prepay.list, { params: obj }),
        updateStatus: obj => request.post(url.prepay.updateStatus, obj),
        update: obj => request.post(url.prepay.update, obj),
    },
    pay: {
        list: obj => request.get(url.pay.list, { params: obj }),
        updateInfo: obj => request.post(url.pay.updateInfo, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateStatus: obj => request.post(url.pay.updateStatus, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        export: params => request.post(url.pay.export, params, { responseType: 'blob' }),
        exportPayDetail: params => request.post(url.pay.exportPayDetail, params, { responseType: 'blob' }),
        totalAmount: obj => request.get(url.pay.totalAmount, { params: obj }),

    },
    withdrawal: {
        list: obj => request.get(url.withdrawal.list, { params: obj }),
        review: obj => request.post(url.withdrawal.review, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateClient: obj => request.post(url.withdrawal.updateClientWithdrawal, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        export: params => request.post(url.withdrawal.export, params, { responseType: 'blob' }),
        updateProvider: obj => request.post(url.withdrawal.confirmProviderWithdrawal, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        withdrawalId: params => request.get(`withdrawal/${params.id}`, params),
        againLaunchPay: obj => request.post(url.withdrawal.againLaunchPay, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        completed: obj => request.post(url.withdrawal.completed, obj),
        /**
        * 人工手动触发提现任务
        * @param withdrawalId 提现单编号
        * @param type 用户角色（1：甲方；2：乙方；0：默认；-1：客服）
        * @return
        */
        transferAccount: obj => request.post(url.withdrawal.transferAccount, obj),
        // getZlbTime:obj=>request.get('https://image.duiyou360.com/common/json/withdrawal-time.json',obj),    
    },


    settlement: {
        list: obj => request.get(url.settlement.list, { params: obj }),
        export: obj => request.post(url.settlement.export, obj, { responseType: 'blob' }),
    },
    payChannel: {
        get: obj => request.get(url.payChannel.get, { params: obj }),
        update: obj => request.get(url.payChannel.update, { params: obj }),
    },
    upload: {
        token: obj => request.get(url.upload.token, { params: obj }),
    },
    job: {
        list: obj => request.get(url.job.list, { params: obj }),
        quotes: obj => request.get(url.job.quotes, { params: obj }),
        push: obj => request.post(url.job.push, obj),
        pushRecords: obj => request.get(url.job.pushRecords, { params: obj }),
        showIndex: params => request.get(url.order.showIndex, { params }),
        cancelShowIndex: params => request.get(url.job.cancelShowIndex, { params }),
        showHot: obj => request.post(url.job.showHot, obj),
        export: obj => request.post(url.job.export, obj, { responseType: 'blob' }),
        detail: obj => request.get(url.job.detail, { params: obj }),
        update: obj => request.post(url.job.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        switch: obj => request.get(url.job.switch, { params: obj }),
        matchAgain: obj => request.get(url.job.matchAgain, { params: obj }),
    },
    standardJob: {
        list: obj => request.post(url.standardJob.list, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        insert: obj => request.post(url.standardJob.insert, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        update: obj => request.post(url.standardJob.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        detail: obj => request.get(url.standardJob.detail, { params: obj }),
        delete: obj => request.post(url.standardJob.delete, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    match: {
        list: obj => request.get(url.match.list, { params: obj }),
        update: obj => request.post(url.match.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        tool: obj => request.get(url.match.tool, { params: obj }),
        config: obj => request.get(url.match.config, { params: obj }),
        updateConfig: obj => request.post(url.match.updateConfig, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    cate: {
        list: obj => request.get(url.cate.list, { params: obj }),
        showInCategory: obj => request.post(url.cate.showInCategory, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        detail: obj => request.get(url.cate.detail, { params: obj }),
    },
    talentPool: {
        list: obj => request.post(url.talentPool.list, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        city: obj => request.get(url.talentPool.city, { params: obj }),
        detail: obj => request.get(url.talentPool.detail, { params: obj }),
    },
    invoice: {
        list: obj => request.get(url.invoice.list, { params: obj }),
        detail: obj => request.get(url.invoice.detail, { params: obj }),
        reject: obj => request.post(url.invoice.reject, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        confirm: obj => request.post(url.invoice.confirm, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        export: obj => request.post(url.invoice.export, obj, { responseType: 'blob' }),

        // export: params => request.post(url.invoice.export,params, { responseType: 'blob' }),


    },
    account: {
        list: obj => request.get(url.account.list, { params: obj }),
        export: params => request.post(url.account.export, params, { responseType: 'blob' }),
    },
    coupon: {
        activities: obj => request.get(url.coupon.activities, { params: obj }),
        coupons: obj => request.get(url.coupon.coupons, { params: obj }),
        create: obj => request.post(url.coupon.create, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        update: obj => request.post(url.coupon.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        detail: obj => request.get(url.coupon.detail, { params: obj }),
        updateStatus: obj => request.post(url.coupon.updateStatus, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        exportExcel: obj => request.post(url.coupon.exportExcel, obj, { responseType: 'blob' }),
        assign: obj => request.post(url.coupon.assign, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        couponCreate: obj => request.post(url.coupon.couponCreate, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        couponPackage: obj => request.get(url.coupon.couponPackage, { params: obj }),
        packageDel: obj => request.get(url.coupon.packageDel, { params: obj }),
        Package: obj => request.get(url.coupon.Package, { params: obj }),
        updatePackage: obj => request.post(url.coupon.updatePackage, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),


    },
    appeal: {
        list: obj => request.get(url.appeal.list, { params: obj }),
        detail: obj => request.get(url.appeal.detail, { params: obj }),
        updateStatus: obj => request.post(url.appeal.updateStatus, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    solution: {
        list: obj => request.get(url.solution.list, { params: obj }),
        detail: obj => request.get(url.solution.detail, { params: obj }),
        create: obj => request.post(url.solution.create, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        update: obj => request.post(url.solution.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    wx: {
        push: obj => request.post(url.wx.push, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    invite: {
        list: obj => request.get(url.invite.list, { params: obj }),
        update: obj => request.post(url.invite.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    interview: {
        detail: obj => request.get(url.interview.detail, { params: obj }),
        calculate: obj => request.post(url.interview.calculate, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        save: obj => request.post(url.interview.save, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    config: {
        get: obj => request.get(url.config.get, { params: obj }),
        updateJobHoverConfig: obj => request.post(url.config.updateJobHoverConfig, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateSubsidyConfig: obj => request.post(url.config.updateSubsidyConfig, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateIdCardBlackList: obj => request.post(url.config.updateIdCardBlackList, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateWithdrawalList: obj => request.post(url.config.updateWithdrawalList, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updatePublishJobList: obj => request.post(url.config.updatePublishJobList, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateKeyWors: obj => request.post(url.config.updateKeyWors, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateRecommendJobs: obj => request.post(url.config.updateRecommendJobs, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        talentSave: obj => request.post(url.config.talentSave, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        talentConfig: obj => request.get(url.config.talentConfig, { params: obj }),
    },
    service: {
        list: obj => request.get(url.service.list, { params: obj }),
        search: obj => request.get(url.service.search, { params: obj }),
        delete: obj => request.post(url.service.delete, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        insert: obj => request.post(url.service.insert, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        show: obj => request.post(url.service.show, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        update: obj => request.post(url.service.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        detail: obj => request.get(url.service.detail, { params: obj }),
        sendProposal: obj => request.post(url.service.sendProposal, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        checkList: obj => request.get(url.service.checkList, { params: obj }),
        editHot: obj => request.post(url.service.editHot, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),

        findHotList: obj => request.get(url.service.findHotList, { params: obj }),
    },
    search: {
        list: obj => request.get(url.search.list, { params: obj }),
        add: obj => request.post(url.search.add, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        update: obj => request.post(url.search.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        delete: obj => request.post(url.search.delete, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    activity: {
        list: obj => request.get(url.activity.list, { params: obj }),
        detail: obj => request.get(url.activity.detail, { params: obj }),
        create: obj => request.post(url.activity.create, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        update: obj => request.post(url.activity.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        delete: obj => request.post(url.activity.delete, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    talentActivity: {
        list: obj => request.post(url.talentActivity.list,  obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        detail: obj => request.get(url.talentActivity.detail, { params: obj }),
        statistics: obj => request.get(url.talentActivity.statistics, { params: obj }),
        create: obj => request.post(url.talentActivity.create, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        update: obj => request.post(url.talentActivity.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        delete: obj => request.post(url.talentActivity.delete, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    ent: {
        list: obj => request.get(url.ent.list, { params: obj }),
        member: obj => request.get(url.ent.member, { params: obj }),
    },
    bean: {
        logs: obj => request.get(url.bean.logs, { params: obj }),
        types: obj => request.get(url.bean.types, { params: obj }),
        export: params => request.post(url.bean.export, params, { responseType: 'blob' }),
        getAllList: obj => request.get(url.bean.getAllList, { params: obj }),
        add: obj => request.post(url.bean.add, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        update: obj => request.post(url.bean.update, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        getConfig: params => request.get(`beanConfig/${params.id}`, params),

    },
    prop: {
        selectTools: obj => request.post(url.prop.selectTools, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        selectProps: obj => request.post(url.prop.selectProps, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        qryPropOrder: obj => request.post(url.prop.qryPropOrder, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        order: obj => request.get(url.prop.order, { params: obj }),
        commitRefund: obj => request.post(url.prop.commitRefund, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        refundList: obj => request.get(url.prop.refundList, { params: obj }),
        refundExport: obj => request.post(url.prop.refundExport, obj, { responseType: 'blob' }),
        agreeRefund: obj => request.post(url.prop.agreeRefund, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        refuseRefund: obj => request.post(url.prop.refuseRefund, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        qryDeliverLog: obj => request.post(url.prop.qryDeliverLog, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        qryChatLog: obj => request.post(url.prop.qryChatLog, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
    },
    taskInfo: {
        pushPartyB: obj => request.post(url.taskInfo.pushPartyB, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        list: obj => request.get(url.taskInfo.list, { params: obj }),
        shelvesTask: obj => request.get(url.taskInfo.shelvesTask, { params: obj }), // 上下架

        updateFee: obj => request.post(url.taskInfo.updateFee, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }), // 修改手续费
        batchAdd: obj => request.post(url.taskInfo.batchAdd, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        updateBatch: obj => request.post(url.taskInfo.updateBatch, obj, {
            headers: {
                'Content-Type': 'application/json'
            }
        }),
        taskInfoId: obj => request.get(url.taskInfo.taskInfoId, { params: obj }),
        pushLogList: obj => request.get(url.taskInfo.pushLogList, { params: obj }),
    },

    callInfo: {
        list: obj => request.get(url.callInfo.list, { params: obj }),
    },
    taskOrder: {
        list: obj => request.get(url.taskOrder.list, { params: obj }),
    },
    taskOrderSettlement: {
        list: obj => request.get(url.taskOrderSettlement.list, { params: obj }),
    }
}



// WEBPACK FOOTER //
// ./src/views/api.js